import { render, staticRenderFns } from "./InboundScanning.vue?vue&type=template&id=4b10957c&"
import script from "./InboundScanning.vue?vue&type=script&lang=js&"
export * from "./InboundScanning.vue?vue&type=script&lang=js&"
import style0 from "./InboundScanning.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports